// extracted by mini-css-extract-plugin
export default {"control":"control_control__dYd6d","addIcon":"control_addIcon__DRmd4"};